import { Button, Grid, Typography, TextField, Box, Hidden
    , FormControl, InputLabel, Select, IconButton, Snackbar, Alert } from "@mui/material";
import { Search as IconSearch, IndeterminateCheckBox as IconIndeterminateCheckBox
    , CheckBox as IconCheckBox, PersonAdd as IconPersonAdd } from "@mui/icons-material";
import * as periodoService from "../../services/periodoService";
import * as catalogoService from "../../services/catalogoService";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { setValue, setListTiposTerapias, setListEstadosApertura, setListEstados } from '../../redux/periodSearchSlice';
import DialogYesNo from '../../components/DialogYesNo';
import DataGridBase from "../../components/common/DataGridBase"
import { useMantenimiento } from "../../hooks/useMantenimiento";

const Index = () => {
    const { isReadOnly } = useMantenimiento("periodo");
    const filters = useSelector((state) => state.periodSearch.filters);
    const listTiposTerapias = useSelector((state) => state.periodSearch.listTiposTerapias);
    const listEstadosApertura = useSelector((state) => state.periodSearch.listEstadosApertura);
    const listEstados = useSelector((state) => state.periodSearch.listEstados);
    const accesos = useSelector((state) => state.seguridad?.accesos) || [];

    const [openDialogAnnulActive, setOpenDialogAnnulActive] = useState(false)
    const openCloseDialogAnnulActive = () => { setOpenDialogAnnulActive(!openDialogAnnulActive); }
    const [openDialogCerrar, setOpenDialogCerrar] = useState(false)
    const openCloseDialogCerrar = () => { setOpenDialogCerrar(!openDialogCerrar); }
    const [selectId, setSelectId] = useState(null);
    const [selectState, setSelectState] = useState(null);
    const [selectCodigo, setSelectCodigo] = useState(null);
    const [cierreTexto, setCierreTexto] = useState("");
    const [openAlertBloqueo, setOpenAlertBloqueo] = useState(false);
    const [alertBloqueoMensaje, setAlertBloqueoMensaje] = useState("");

    // Cerrar un periodo solo lo puede hacer quien tenga el acceso periodo.cerrar
    // (Administrador y Director). Sin seguridad activa o sin accesos cargados se
    // concede, que es el comportamiento permisivo del resto del sistema.
    const puedeCerrar = !isReadOnly && (accesos.length === 0 || accesos.includes("periodo.cerrar"));

    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const fetchResults = async () => {
        setCargando(true);

        await periodoService.getsPeriodoView(filters)
            .then((data) => {
                setResults(data);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchTiposTerapias = async () => {
        await catalogoService.getCatalogosByPadre(49)
            .then((data) => {
                dispatch(setListTiposTerapias(data));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchEstadosApertura = async () => {
        await catalogoService.getCatalogosByPadre(86)
            .then((data) => {
                dispatch(setListEstadosApertura(data));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchEstados = async () => {
        await catalogoService.getCatalogosByPadre(1)
            .then((data) => {
                dispatch(setListEstados(data));
                dispatch(setValue({name: "idEstado", value: 2}))
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const annul = async () => {
        await periodoService.annulPeriodo(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
            fetchResults();
    }
    const active = async () => {
        await periodoService.activePeriodo(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
            fetchResults();
    }
    // Cierra el periodo elegido: el estado de apertura pasa de Abierto a Cerrado.
    const cerrar = async () => {
        setCargando(true);
        try {
            await periodoService.cerrarPeriodo(selectId);
        } catch (err) {
            setCargando(false);
            console.log("Err: ", err);
            const msg = err.response?.data?.detail || err.response?.data?.message || "No se pudo cerrar el periodo.";
            setAlertBloqueoMensaje(msg);
            setOpenAlertBloqueo(true);
        }
        fetchResults();
    }

    const iniciarCierre = async (id, codigo) => {
        setSelectId(id);
        setSelectCodigo(codigo);
        try {
            setCargando(true);
            const res = await periodoService.verificarCierrePeriodo(id);
            setCargando(false);
            const info = res?.data?.data;
            if (info?.bloquearCierre) {
                setAlertBloqueoMensaje(info.mensaje || "No se puede cerrar el periodo porque existen saldos pendientes y la configuración del sistema lo restringe.");
                setOpenAlertBloqueo(true);
                return;
            }

            if (info?.tieneDeuda) {
                setCierreTexto(`Existen ${info.cantidadPendientes} participante(s) con saldos pendientes por cobrar (S/ ${info.montoTotalDeuda?.toFixed(2)}) o sin comprobante en el periodo ${codigo}. ¿Desea proceder con el cierre de todos modos? (Un periodo cerrado puede reabrirse si es necesario).`);
            } else {
                setCierreTexto(`¿Está seguro de cerrar el periodo ${codigo}? Un periodo cerrado ya no admite Planeamiento ni Apertura de periodos de terapia.`);
            }
            setOpenDialogCerrar(true);
        } catch (err) {
            setCargando(false);
            console.error("Error al verificar cierre de periodo: ", err);
            setCierreTexto(`¿Está seguro de cerrar el periodo ${codigo}? Un periodo cerrado ya no admite Planeamiento ni Apertura de periodos de terapia.`);
            setOpenDialogCerrar(true);
        }
    }

    useEffect(() => {
        fetchResults();
        fetchTiposTerapias();
        fetchEstadosApertura();
        fetchEstados();
    }, []);

    const columns = [
        { field: 'id', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        // { field: 'id', headerName: 'ID', width: 50, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'codigo', headerName: 'Codigo', width: 120, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return <Link to={'/period/edit/' + cellValues.row.id} style={{ color: 'inherit' }}>{cellValues.row.codigo}</Link>;
            }
        },
        { field: 'tipoTerapia', headerName: 'Tipo Terapia', width: 100, sortable: false, headerAlign: 'center'},
        { field: 'periodicidad', headerName: 'Periodicidad', width: 110, sortable: false, headerAlign: 'center'},
        { field: 'estadoApertura', headerName: 'Apertura', width: 100, sortable: false, headerAlign: 'center', align: 'center' },
        // Cerrar el periodo es una accion sensible: la concede el acceso
        // periodo.cerrar (Administrador y Director). Solo se ofrece en los
        // periodos que estan abiertos.
        { field: 'cerrar', headerName: '', width: 80, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                const abierto = cellValues.row.estadoApertura === "Abierto";

                if (!abierto || !puedeCerrar) return "";

                return <Link onClick={() => {
                    iniciarCierre(cellValues.row.id, cellValues.row.codigo);
                }} style={{ color: 'inherit', cursor: 'pointer' }}>
                    Cerrar
                </Link>;
            }
        },
        { field: 'estado', headerName: 'Estado', width: 80, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'anular', headerName: '', width: 80, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                return <IconButton aria-label="anular" size='small' style={{height: 10}} align={"center"} disabled={isReadOnly} onClick={() => {
                    setSelectId(cellValues.row.id);
                    setSelectState(cellValues.row.estado);
                    setOpenDialogAnnulActive(true);
                }}>
                    { cellValues.row.estado == "A" ? <IconIndeterminateCheckBox /> : <IconCheckBox /> }
                </IconButton>;
            }
        },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Periodos
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container item xs={12} sm={12} spacing={1}>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-tipoterapia">Tipo Terapia</InputLabel>
                                    <Select
                                        native
                                        label="Tipo Terapia"
                                        value={filters.idTipoTerapia}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idTipoTerapia", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idTipoTerapia',
                                            id: 'input-tipoterapia',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listTiposTerapias.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-estadoapertura">Apertura</InputLabel>
                                    <Select
                                        native
                                        label="Estado Apertura"
                                        value={filters.idEstadoApertura}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idEstadoApertura", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idEstadoApertura',
                                            id: 'input-estadoapertura',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listEstadosApertura.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <TextField
                                    // required
                                    inputProps={{ type: 'number'}}
                                    name="mesesHaciaAtras"
                                    label="Meses Hacia Atras"
                                    value={filters.mesesHaciaAtras}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "mesesHaciaAtras", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-estado">Estado</InputLabel>
                                    <Select
                                        native
                                        label="Estado"
                                        value={filters.idEstado}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idEstado", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idEstado',
                                            id: 'input-estado',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listEstados.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={1} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" size="medium" fullWidth onClick={() => {
                                    fetchResults()
                                }}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                disabled={isReadOnly}
                                toolbarButtons={[
                                    {
                                        text: "Nuevo",
                                        icon: <IconPersonAdd />,
                                        disabled: isReadOnly,
                                        onClick: () => navigate("/period/edit/0")
                                    }
                                ]}
                                // onNewClick={() => navigate(`/period/edit/0`)}
                            />
                        </Box>
                    </Grid>
                    <DialogYesNo open={openDialogAnnulActive} openClose={openCloseDialogAnnulActive} setYes={ selectState == "A" ? annul : active} 
                        setNo={() => { return }}
                        titulo={(selectState == "A" ? "Anular" : "Activar") + " Periodo"}
                        texto={"Esta seguro de " + (selectState == "A" ? "anular" : "activar") + " el periodo?"} >
                    </DialogYesNo>
                    <DialogYesNo open={openDialogCerrar} openClose={openCloseDialogCerrar} setYes={cerrar}
                        setNo={() => { return }}
                        titulo={"Cerrar Periodo"}
                        texto={cierreTexto} >
                    </DialogYesNo>
                    <Snackbar open={openAlertBloqueo} autoHideDuration={7000} onClose={() => setOpenAlertBloqueo(false)}
                        anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                        <Alert onClose={() => setOpenAlertBloqueo(false)} severity="error" sx={{ width: '100%' }}>
                            {alertBloqueoMensaje}
                        </Alert>
                    </Snackbar>
                </Grid>
            </Grid>
        </div>
    )
}
export default Index
